const namespace = 'ShopDetail';

export const SET_SHOP_NETWORK_MENU = `${namespace}/SET_SHOP_NETWORK_MENU`;
export const SET_SHOP_DETAIL = `${namespace}/SET_SHOP_DETAIL`;
